import classes from "./menu.module.scss";

import { useMemo } from "react";
import { Link } from "react-router-dom";

import { IconHivery } from "@app/components";
import { getAppPaths } from "@app/routes/app-paths";
import { Tooltip } from "@honeycomb/ui";

export interface MenuLinkHomeProps {
  height?: string;
  width?: string;
}

export const MenuLinkHome = ({ height = "39px", width = "39px" }: MenuLinkHomeProps) => {
  const appPaths = useMemo(() => {
    return getAppPaths();
  }, []);

  return (
    <Tooltip placement="right" title={"Curate Home"}>
      <Link className={classes["hivery-icon"]} to={`/${appPaths.home}`}>
        <IconHivery height={height} width={width} />
      </Link>
    </Tooltip>
  );
};
